/**
 * Import
 * - Libraries
 */
import { connect } from 'react-redux'

/**
 * Import
 * - Store
 */
import { RootState } from '../../../store'

/**
 * Import
 * - Actions
 */
import {
    issueViewQuoteVariation,
    bindQuoteVariation,
    getQuoteSingle,
    handleReissueQuote,
    confirmEditQuote,
    fetchLocations,
} from '../../../actions'

/**
 * Import
 * - Page component
 */
import ViewQuote from '../../../components/pages/Quote/ViewQuote/ViewQuote'

const mapStateToProps = (state: RootState, props: any) => {
    return {
        quote: state.quotesSingle,
        step05: state.step05,
        step05Bind: state.quote.step05,
        riskLocations: state.quote.riskLocations,
    }
}

export default connect(
    mapStateToProps,
    {
        issueViewQuoteVariation: issueViewQuoteVariation,
        bindQuoteVariation: bindQuoteVariation,
        handleReissueQuote: handleReissueQuote,
        getQuoteSingle: getQuoteSingle,
        confirmEditQuote,
        fetchLocations,
    }
)(ViewQuote)



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/containers/pages/Quote/ViewQuote.tsx